/**
 * Created by jv on 2019-09-10 (14:34).
 */

const log = require("Sources/utils/logger")();
import utils from "Sources/utils/utils";
// import CONSTANTS from "Sources/config/constants";
import GameView from "Sources/components/game/views/game-view";
import htmlView from "Views/partials/game/business-model.html";
import LanguageManager from "Sources/services/language-manager";

import BusinessModel from "Sources/components/business-model/business-model";
import testLayout from "Sources/components/business-model/layouts/default"; // %NOTE: CMS.faq also uses this config, please change there too :)
import InvestmentsView from "Sources/components/game/components/investments-view";
import InvestmentDialog from "Sources/components/game/components/investment-dialog";
import EventDialog from "Sources/components/game/components/event-dialog";
// import ScoreScreen from "Sources/components/game/components/score-screen";
import RankingScreen from "Sources/components/game/components/ranking-screen";

import Shared from "Sources/shared";
import InfoWasteDepotView from "Sources/components/popup/info-waste-depot";
import InfoMarketView from "Sources/components/popup/info-market";
import InfoMiningView from "Sources/components/popup/info-mining";
import InfoFactoryView from "Sources/components/popup/info-factory";
import IntroInvestmentsView from "Sources/components/popup/intro-investments";
import IntroSellView from "Sources/components/popup/intro-sell";
import IntroEmployeesView from "Sources/components/popup/intro-employees";

const investmentIcons = require.context("!raw-loader!Images/business-model/investments/info", false, /\.svg$/);
const resourceIconsRawLoader = require.context("!raw-loader!Images/business-model/resource-icons", false, /\.svg$/);
const resourceIcons = require.context("Images/business-model/resource-icons", false, /\.svg$/);
const infoIcons = require.context("!raw-loader!Images/info", false, /\.svg$/);

require("Styles/components/views/business-model.scss");

class BusinessModelView extends GameView
{
    constructor(options)
    {
        options.html = $(htmlView);
        super(options);

        this.path = "business-model";

        this.businessModel = null;

        this.gameSession = options.gameSession;
        this.team = options.team;
        this.caseWrapper = options.caseWrapper;
        this.roundOverview = options.roundOverview;

        // this.scoreScreenMode = null;
        this.rankingScreenMode = null;

        this.onRenderCompleted = options.onRenderComplete;

        this.onInvestmentAdded = options.onInvestmentAdded;
        this.onAssignEmployee = options.onAssignEmployee;
        this.onNextPhaseRequested = options.onNextPhaseRequested;
        this.onTeamClosedRound = options.onTeamClosedRound;
        this.onTeamOverviewChanged = options.onTeamOverviewChanged;

        this.executeOnRender = [];
        this.executeOnEventClose = [];
        this.executeOnInvestmentClose = [];

        this.showBusinessModelOnRender = true;

        this.guidedIntroduction = {};

        this.onAssignMineEmployee = options.onAssignMineEmployee;
        this.onAssignMicrochipEmployee = options.onAssignMicrochipEmployee;
        this.onAssignSecondaryEmployee = options.onAssignSecondaryEmployee;
        this.onAssignWasteRecycleEmployee = options.onAssignWasteRecycleEmployee;
        this.onAssignReuseEmployee = options.onAssignReuseEmployee;
        this.onAssignRentalEmployee = options.onAssignRentalEmployee;

        this.resourceTooltipTimeouts = {};
    }

    render()
    {
        super.render();

        this.rendered = false;

        this.$element.find(".bm-action__data.bm-data__budget").prop("disabled", true);
        this.$element.find(".bm-action__data.bm-data__points").prop("disabled", true);

        this.$loader = this.$element.find(".business-model__loader");
        this.$businessModelCanvas = this.$element.find(".bm__canvas");
        // this.$scoreScreenContainer = this.$element.find(".bm__score-screen");
        this.$rankingScreenContainer = this.$element.find(".bm__ranking-screen");
        this.$investmentWrapper = this.$element.find(".investment__wrapper");
        this.$actionBarWrapper = this.$element.find(".action-bar__wrapper");
        this.$actionBarMain = this.$element.find(".action-bar.action-bar__main");

        this.renderBusinessModelCanvas();
        // this.renderScoreScreen();
        this.renderRanking();
        this.renderInvestmentsCarousel();
        this.renderInvestmentDialog();
        this.renderEventDialog();

        this.showBusinessModel(false);
        this.showLoader(true);

        this._setUpEventListeners();
    }

    onRender()
    {
        super.onRender();

        log.info("Business model has rendered");

        this.rendered = true;

        this.clearSidebarResourceData();
        this.refreshRoundData();

        if (this.showBusinessModelOnRender)
        {
            // this.showBusinessModel(true, false);
        }

        switch (this.roundOverview.currentRoundData.phase)
        {
            case 0: // Investments
                this.showInvestments();
                break;

            case 1: // Game view
                this.showBusinessModel(true, false);
                break;

            case 2: // Sell view
                this.showSellProducts();
                break;
        }

        this.$element.find(".bm-action__data.bm-data__budget").prop("disabled", false);
        this.$element.find(".bm-action__data.bm-data__points").prop("disabled", false);

        for (let i = 0; i < this.executeOnRender.length; i++)
        {
            if (utils.isFunction(this.executeOnRender[i]))
            {
                this.executeOnRender[i].call(this);
            }
        }

        if (utils.isFunction(this.onRenderCompleted))
        {
            this.onRenderCompleted.call(this);
        }
    }

    renderBusinessModelCanvas()
    {
        if (this.businessModel)
        {
            this.businessModel.destroy();
        }

        this.businessModel = new BusinessModel({
            containerElement: this.$businessModelCanvas,
            layoutData: testLayout,
            roundOverview: this.roundOverview,
            team: this.team,
            factories: this.caseWrapper.factories,
            view: this,
            onRenderComplete: () =>
            {
                this.businessModel.income = this.roundOverview.currentRoundData.currentIncome;
                this.onRender();
            },
            onAssignEmployee: (factory) =>
            {
                this.assignEmployee(factory);
            },
            onInfoScreenRequested: (info) =>
            {
                this.showInfoScreen(info, "info");
            },
            onInactiveSpotClick: () =>
            {
                if (utils.isFunction(this.onInactiveSpotClick))
                {
                    this.onInactiveSpotClick.call(this);
                }
            },
            onAssignMineEmployee: () =>
            {
                if (utils.isFunction(this.onAssignMineEmployee))
                {
                    this.onAssignMineEmployee.call(this);
                }
            },
            onAssignMicrochipEmployee: () =>
            {
                if (utils.isFunction(this.onAssignMicrochipEmployee))
                {
                    this.onAssignMicrochipEmployee.call(this);
                }
            },
            onAssignSecondaryEmployee: () =>
            {
                if (utils.isFunction(this.onAssignSecondaryEmployee))
                {
                    this.onAssignSecondaryEmployee.call(this);
                }
            },
            onAssignWasteRecycleEmployee: () =>
            {
                if (utils.isFunction(this.onAssignWasteRecycleEmployee))
                {
                    this.onAssignWasteRecycleEmployee.call(this);
                }
            },
            onAssignReuseEmployee: () =>
            {
                if (utils.isFunction(this.onAssignReuseEmployee))
                {
                    this.onAssignReuseEmployee.call(this);
                }
            },
            onAssignRentalEmployee: () =>
            {
                if (utils.isFunction(this.onAssignRentalEmployee))
                {
                    this.onAssignRentalEmployee.call(this);
                }
            }
        });

        log.info("Rendering business model: %o", this.businessModel);

        this.businessModel.render();
    }

    renderRanking()
    {
        if (utils.isNotNull(this.rankingScreen))
        {
            this.rankingScreen.destroy();
        }

        this.rankingScreen = new RankingScreen({
            platform: "student",
            container: this.$rankingScreenContainer,
            team: this.team,
            teams: this.gameSession.teamList,
            callbackContext: this,
        });

        this.rankingScreen.render();
    }

    renderInvestmentsCarousel()
    {
        if (utils.isNotNull(this.investmentsView))
        {
            this.investmentsView.destroy();
        }

        this.investmentsView = new InvestmentsView({
            container: this.$investmentWrapper,
            team: this.team,
            roundOverview: this.roundOverview,
            investments: this.caseWrapper.investments,
            onInvestmentClicked: (investment) => this.onInvestmentClicked(investment)
        });

        this.investmentsView.render();
    }

    renderInvestmentDialog()
    {
        if (utils.isNotNull(this.investmentDialog))
        {
            this.investmentDialog.destroy();
        }

        this.investmentDialog = new InvestmentDialog({
            team: this.team,
            roundOverview: this.roundOverview,
            investments: this.caseWrapper.investments,
            callbackContext: this,
            onCancel: this.onInvestmentDialogCancel,
            onPurchase: this.onInvestmentPurchased
        });

        this.investmentDialog.create();
    }

    renderEventDialog()
    {
        if (utils.isNotNull(this.eventDialog))
        {
            this.eventDialog.destroy();
        }

        this.eventDialog = new EventDialog({
            callbackContext: this,
            onCancel: this.onEventDialogCancel,
        });

        this.eventDialog.create();
    }

    hide()
    {
        super.hide();

        if (utils.isNotNull(this.investmentDialog))
        {
            // Also hide dialogs when hiding the game view!
            this.hideAllDialogs();
        }
    }

    hideAllDialogs()
    {
        this.hideInvestmentDialog();
        this.hideEventDialog();
    }

    showBusinessModel(flag, hideOthers, removePreview)
    {
        if (flag)
        {
            if (hideOthers !== false)
            {
                this.hideAllDialogs();
                this.hideInvestments();
                // this.hideScoreScreen();
                this.hideRankingScreen();
            }

            this.$element.find(".bm-action-btn").removeClass("bm-action__active");
            this.$element.find(".bm-action-btn__model").addClass("bm-action__active");

            if (this.businessModel.hasRendered())
            {
                this.showLoader(false);
                this.$businessModelCanvas.show();

                this.checkGuidedIntroduction("employees-1");

                // if(utils.isNotNull(this.hideCanvasAnimationTimeout))
                // {
                //   clearTimeout(this.hideCanvasAnimationTimeout);
                //   this.hideCanvasAnimationTimeout = null;
                // }
                //
                // this.$businessModelCanvas.show();
                // this.$businessModelCanvas.addClass("bm__visible");
            }
            else
            {
                this.showBusinessModelOnRender = true;
                this.showLoader(true);
            }
        }
        else
        {
            // if(utils.isNotNull(this.hideCanvasAnimationTimeout))
            // {
            //   clearTimeout(this.hideCanvasAnimationTimeout);
            //   this.hideCanvasAnimationTimeout = null;
            // }
            //
            // this.$businessModelCanvas.removeClass("bm__visible");
            // this.hideCanvasAnimationTimeout = setTimeout(() =>
            // {
            //   this.hideCanvasAnimationTimeout = null;
            //   this.$businessModelCanvas.hide();
            // }, CONSTANTS.BM_TRANSITION_SPEED);

            this.$businessModelCanvas.hide();
        }
    }

    showLoader(flag)
    {
        this.showRandomFact(flag);

        if (flag)
        {
            this.hideAllDialogs();
            this.hideSellProducts();
            this.hideInvestments();
            // this.hideScoreScreen();
            this.hideRankingScreen();

            this.$loader.show();
        }
        else
        {
            this.$loader.hide();
        }
    }

    showRandomFact()
    {
        let titleContainer = this.$loader.find(".business-model__loader-facts-title");
        let factContainer = this.$loader.find(".business-model__loader-facts-fact");
        let fact = randomInt(1, 3);

        let key = "serious_game.business_model.loading.fact." + fact;
        let title = LanguageManager.getValueForKey(key + ".title");
        let description = LanguageManager.getValueForKey(key + ".description");

        titleContainer.html(title);
        factContainer.html(description);

        function randomInt(min, max)
        {
            return Math.floor(Math.random() * (max - min + 1) + min)
        }
    }

    showInfoScreen(info, mode, data)
    {
        log.info(info);

        let container = $("<div>");
        let options = { container: container, mode: mode, data: data };
        let extraModalContentClass;

        switch (info.type)
        {
            case "info-mine":
                new InfoMiningView(options).render();
                extraModalContentClass = "info-mining-background-container";
                break;

            case "info-factory":
                new InfoFactoryView(options).render();
                extraModalContentClass = "info-factory-background-container";
                break;

            case "info-waste_depot":
                new InfoWasteDepotView(options).render();
                extraModalContentClass = "info-waste-depot-background-container";
                break;

            case "info-market":
                new InfoMarketView(options).render();
                extraModalContentClass = "info-market-background-container";
                break;

            default:
                return;
        }

        Shared.Dialog.showMessageDialog({
            title: mode === "feedback" ? null : "info.title",
            message: container,
            disposable: false,
            extraModalContentClass: extraModalContentClass
        });
    }

    // showScoreScreen(options)
    // {
    //     if (!this.rendered)
    //     {
    //         this.executeOnRender.push(() => this.showScoreScreen(options));
    //         return;
    //     }
    //
    //     let title = options.title,
    //         roundIndex = options.roundIndex,
    //         asOverlay = options.asOverlay === true;
    //
    //     this.scoreScreenMode = options.mode || "current-round";
    //
    //     this.scoreScreen.isFinal = this.scoreScreenMode === "endgame";
    //     this.scoreScreen.title = title;
    //     this.scoreScreen.roundIndex = roundIndex;
    //     this.scoreScreen.team = this.team;
    //     this.scoreScreen.roundOverview = this.roundOverview;
    //     this.scoreScreen.interactive = options.interactive === true;
    //
    //     this.showLoader(false);
    //     this.hideInvestments();
    //     this.hideAllDialogs();
    //
    //     if (asOverlay)
    //     {
    //         this.showBusinessModel(true, false);
    //         this.$scoreScreenContainer.removeClass("bm__background-filled");
    //     }
    //     else
    //     {
    //         if (options.keepVisible === true) this.showBusinessModelOnRender = false;
    //
    //         if (options.hideBusinessModel !== false)
    //         {
    //             this.showBusinessModel(false);
    //         }
    //
    //         this.$scoreScreenContainer.addClass("bm__background-filled");
    //     }
    //
    //     this.$element.find(".bm-action-btn").removeClass("bm-action__active");
    //     this.$element.find(".bm-action-btn__score").addClass("bm-action__active");
    //
    //     this.scoreScreen.show(asOverlay);
    //     this.$scoreScreenContainer.show().addClass("bm__visible");
    // }

    showRankingScreen(options)
    {
        if (!this.rendered)
        {
            this.executeOnRender.push(() => this.showRankingScreen(options));
            return;
        }

        let roundIndex = options.roundIndex,
            asOverlay = options.asOverlay === true;

        this.rankingScreenMode = options.mode || "current-round";

        this.rankingScreen.isFinal = this.rankingScreenMode === "endgame";
        this.rankingScreen.roundIndex = roundIndex;
        this.rankingScreen.team = this.team;
        this.rankingScreen.roundOverview = this.roundOverview;
        this.rankingScreen.interactive = options.interactive === true;

        this.showLoader(false);
        this.hideInvestments();
        this.hideAllDialogs();

        if (asOverlay)
        {
            this.showBusinessModel(true, false);
            this.$rankingScreenContainer.removeClass("bm__background-filled");
        }
        else
        {
            if (options.keepVisible === true) this.showBusinessModelOnRender = false;

            if (options.hideBusinessModel !== false)
            {
                this.showBusinessModel(false);
            }

            this.$rankingScreenContainer.addClass("bm__background-filled");
        }

        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
        this.$element.find(".bm-action-btn__score").addClass("bm-action__active");

        this.rankingScreen.show(asOverlay);
        this.$rankingScreenContainer.show().addClass("bm__visible");
    }

    // updateScoreScreen()
    // {
    //     this.scoreScreen.team = this.team;
    //     this.scoreScreen.roundOverview = this.roundOverview;
    //     this.scoreScreen.update();
    // }

    updateRankingScreen()
    {
        this.rankingScreen.team = this.team;
        this.rankingScreen.roundOverview = this.roundOverview;
        this.rankingScreen.update();
    }

    updateTeamList(teamList)
    {
        this.gameSession.teamList = teamList;

        // if (utils.isNotNull(this.scoreScreen))
        // {
        //     this.scoreScreen.updateTeamList(teamList);
        // }

        if (utils.isNotNull(this.rankingScreen))
        {
            this.rankingScreen.updateTeamList(teamList);
        }
    }

    // hideScoreScreen(removeBackdrop)
    // {
    //     this.scoreScreen.hide();
    //     this.$scoreScreenContainer.removeClass("bm__visible");
    // }

    hideRankingScreen(removeBackdrop)
    {
        this.rankingScreen.hide();
        this.$rankingScreenContainer.removeClass("bm__visible");
    }

    checkGuidedIntroductionFeedback(feedback)
    {
        let tutorialName = this.guidedIntroduction.CURRENT;

        log.info("GUIDED INTRO, check feedback: " + feedback + ", current tutorial: " + tutorialName);

        if (utils.isNotNull(tutorialName))
        {
            if (tutorialName === "investments")
            {
                if (feedback === "investment-made")
                {
                    $("#btn-next-phase").prop("disabled", false);

                    this.checkGuidedIntroduction("investment-done", () =>
                    {
                        let timeoutId = setTimeout(function()
                        {
                            $("#btn-next-phase").addClass("seeking-attention");
                        }, 3000);

                        $("#btn-next-phase").data("seeking-attention-timeout", timeoutId);
                    });
                }
            }
            else if (tutorialName === "employees-1")
            {
                if (feedback === "assigned-employee")
                {
                    $("#btn-next-phase").prop("disabled", false);
                    this.checkGuidedIntroduction("employees-2");
                }
            }
            else if (tutorialName === "employees-2")
            {
                if (feedback === "assigned-employee")
                {
                    $("#btn-next-phase").prop("disabled", false);
                    this.checkGuidedIntroduction("employees-3");
                }
            }
            else if (tutorialName === "employees-3")
            {
                if (feedback === "assigned-employee")
                {
                    $("#btn-next-phase").prop("disabled", false);

                    this.checkGuidedIntroduction("employees-4", () =>
                    {
                        let timeoutId = setTimeout(function()
                        {
                            $("#btn-next-phase").addClass("seeking-attention");
                        }, 3000);

                        $("#btn-next-phase").data("seeking-attention-timeout", timeoutId);
                    });
                }
            }
        }
    }

    checkGuidedIntroduction(tutorialName, onConfirm)
    {
        if (utils.isNotNull(this.guidedIntroduction[tutorialName]))
        {
            log.info("GUIDED INTRO, already seen: " + tutorialName);
            return;
        }

        if (utils.isNotNull(this.gameSession))
        {
            if (utils.isNotNull(this.gameSession.team))
            {
                if (this.gameSession.team.currentRound !== 0)
                {
                    log.info("GUIDED INTRO, not seen: " + tutorialName + ", but not in first round...");
                    return;
                }
            }
        }

        this.guidedIntroduction[tutorialName] = 1;
        this.guidedIntroduction.CURRENT = tutorialName;

        let team = this.gameSession.team;
        let factoryRoundData = team.factoryRoundData;
        let container = $("<div>");
        let view = null;
        let currentPhase = team.roundData[0].phase;
        let neededPhase = -1;
        let actions = null;

        function hasUsedEmployees(factoryIndex)
        {
            if (utils.isNotNull(factoryRoundData))
            {
                if (utils.isNotNull(factoryRoundData[factoryIndex]))
                {
                    let factory = factoryRoundData[factoryIndex];

                    return factory.usedEmployees || 0;
                }
            }

            return 0;
        }

        if (tutorialName === "investments")
        {
            view = new IntroInvestmentsView({ container: container, tutorialName: tutorialName });
            neededPhase = 0;

            actions = () =>
            {
                $("#btn-next-phase").prop("disabled", "disabled");
            }
        }
        else if (tutorialName === "investment-done")
        {
            view = new IntroInvestmentsView({ container: container, tutorialName: tutorialName });
            neededPhase = 0;
        }
        else if (tutorialName.startsWith("employees-"))
        {
            view = new IntroEmployeesView({ container: container, tutorialName: tutorialName });
            neededPhase = 1;

            if (tutorialName === "employees-1")
            {
                if (hasUsedEmployees(0) > 0)
                {
                    log.info("GUIDED INTRO, not seen " + tutorialName + ", but already has employee assigned to mine");
                    this.checkGuidedIntroductionFeedback("assigned-employee");
                    return;
                }

                actions = () =>
                {
                    this.businessModel.enableTutorialNamedEmployeeSpot("mine-1");
                    $("#btn-next-phase").prop("disabled", "disabled");
                }
            }
            else if (tutorialName === "employees-2")
            {
                if (hasUsedEmployees(0) > 1)
                {
                    log.info("GUIDED INTRO, not seen " + tutorialName + ", but already has employee assigned to mine");
                    this.checkGuidedIntroductionFeedback("assigned-employee");
                    return;
                }

                actions = () =>
                {
                    this.businessModel.enableTutorialNamedEmployeeSpot("mine-2");
                    $("#btn-next-phase").prop("disabled", "disabled");
                }
            }
            else if (tutorialName === "employees-3")
            {
                if (hasUsedEmployees(1) > 0)
                {
                    log.info("GUIDED INTRO, not seen, but already has employee assigned to microchip factory");
                    this.checkGuidedIntroductionFeedback("assigned-employee");
                    return;
                }

                actions = () =>
                {
                    this.businessModel.enableTutorialNamedEmployeeSpot("microchip-1");
                    $("#btn-next-phase").prop("disabled", "disabled");
                }
            }
        }
        else if (tutorialName === "sell")
        {
            view = new IntroSellView({ container: container });
            neededPhase = 2;

            actions = () =>
            {
                $("#btn-next-phase").prop("disabled", "disabled");
            }
        }

        if (currentPhase !== neededPhase)
        {
            log.info("GUIDED INTRO, not seen, but not in correct phase");
            return;
        }

        if (view !== null)
        {
            log.info("GUIDED INTRO, not seen: " + tutorialName, "gameSession:", this.gameSession);

            view.render();

            if (actions !== null)
            {
                actions();
            }

            Shared.Dialog.showMessageDialog({
                message: container,
                dialogId: "intro-" + tutorialName + "-modal-dialog",
                disposable: false,
                onConfirm: () =>
                {
                    if (actions !== null)
                    {
                        actions();
                    }

                    if (utils.isNotNull(onConfirm))
                    {
                        onConfirm();
                    }
                }
            });
        }
    }

    showInvestments()
    {
        log.debug("Showing investments slider");

        this.checkGuidedIntroduction("investments");

        this.showBusinessModel(false, true);

        this.showLoader(false);
        this.investmentsView.show();

        $("body").addClass("game__investments-open");
        this.$investmentWrapper.show().addClass("bm__visible");

        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
        this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);
    }

    hideInvestments(hideOverlay)
    {
        $("body").removeClass("game__investments-open");
        this.$investmentWrapper.removeClass("bm__visible");

        this.investmentsView.hide();

        this.$element.find(".bm-action-btn__investments").removeClass("bm-action__active").prop("disabled", false);
    }

    showInvestmentDialog(investment, asInfo)
    {
        if (this.investmentDialog.isOpen)
        {
            return;
        }

        if (utils.isNotNull(investment)) this.investmentDialog.investment = investment;
        if (utils.isNull(this.investmentDialog.investment)) return;

        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
        this.$element.find(".bm-action-btn__investments").addClass("bm-action__active").prop("disabled", true);

        log.info("INVESTMENT: ", investment, this.$element.find(".investment-image"));

        this.investmentDialog.$dialog.find(".investment-image").html(investmentIcons("./" + investment.imagePopup));

        let title = this.investmentDialog.$dialog.find(".investment-title");
        title.addClass(investment.calculatedCSSClass);
        title.html(LanguageManager.getValueForKey(`investment.${investment.title}.title`));

        if (investment.points > 0)
        {
            this.investmentDialog.$dialog.find(".investment-points").show();
        }
        else
        {
            this.investmentDialog.$dialog.find(".investment-points").hide();
        }

        let description = LanguageManager.getValueForKey(`investment.${investment.title}.description`);
        description = description.replaceAll("{coins-icon}", this.getCoinsIcon());
        this.investmentDialog.$dialog.find(".investment-description").html(description);

        if (investment.imageBackground)
        {
            this.investmentDialog.$dialog.find(".investment-background-image").html(infoIcons("./" + investment.imageBackground));
        }
        else
        {
            this.investmentDialog.$dialog.find(".investment-background-image").hide();
        }

        if (investment.market)
        {
            this.investmentDialog.$dialog.find(".market-price").text(investment.market.price);
            this.investmentDialog.$dialog.find(".market-price-production-icon").html(resourceIconsRawLoader("./" + investment.market.image));

            this.investmentDialog.$dialog.find(".investment-market-price").show();
        }
        else
        {
            this.investmentDialog.$dialog.find(".investment-market-price").hide();
        }

        LanguageManager.applyLocale(this.investmentDialog.$dialog);

        this.investmentDialog.team = this.team;
        this.investmentDialog.roundOverview = this.roundOverview;
        this.investmentDialog.show(asInfo);
    }

    getCoinsIcon()
    {
        return "<img src='" + resourceIcons("./coins.svg") + "' style='width: 25px;'/>";
    }

    hideInvestmentDialog()
    {
        if (utils.isNotNull(this.investmentDialog))
        {
            this.investmentDialog.hide();
        }
    }

    showSellProducts()
    {
        // TODO : Show the sell products screen here
    }

    hideSellProducts()
    {
        // TODO : Hide the sell products screen here
    }

    showEventDialog(moveActionBarBackwards, executeOnClose)
    {
        if (this.eventDialog.isOpen)
        {
            return;
        }

        if (utils.isFunction(executeOnClose))
        {
            this.executeOnEventClose.push(executeOnClose);
        }

        // this.showBusinessModel(true, true);

        this.$element.find(".bm-action-btn").removeClass("bm-action__active");
        this.$element.find(".bm-action-btn__event").addClass("bm-action__active");

        let event = this.roundOverview.currentEvent;

        this.eventDialog.event = event;
        this.eventDialog.show();
    }

    hideEventDialog()
    {
        this.eventDialog.hide();
    }

    refreshRoundData()
    {
        if (utils.isNotNull(this.$element) && this.$element.length)
        {
            this.updateActivePhase();
            this.updateResources();
            this.setActionButtonState();

            // Update business model
            if (utils.isNotNull(this.businessModel))
            {
                this.businessModel.income = this.roundOverview.currentRoundData.currentIncome;

                let teamInvestments = this.getInvestmentObjectsForTeam();
                teamInvestments = teamInvestments.map(ti => ti.type);

                let productIcon = null;
                let extraProductIcon = null;

                for (let i = 0; i < this.caseWrapper.icons.length; i++)
                {
                    let icon = this.caseWrapper.icons[i];

                    if (icon.type === "product")
                    {
                        productIcon = icon;
                    }
                    else if (utils.isNotNull(this.roundOverview.currentRoundData.extraProductId) && this.roundOverview.currentRoundData.extraProductId === icon.type)
                    {
                        extraProductIcon = icon;
                    }
                }
            }

            // Update investments slider
            this.investmentsView.team = this.team;
            this.investmentsView.investments = this.caseWrapper.investments;
            this.investmentsView.roundOverview = this.roundOverview;

            // Update investment dialog
            this.investmentDialog.team = this.team;
            this.investmentDialog.investments = this.caseWrapper.investments;
            this.investmentDialog.roundOverview = this.roundOverview;
            this.investmentDialog.renderDialogContent();

            // Update event dialog
            if (utils.isNotNull(this.roundOverview.currentEvent))
            {
                this.eventDialog.event = this.roundOverview.currentEvent;
            }

            // Update score screen
            // this.scoreScreen.roundOverview = this.roundOverview;
            this.rankingScreen.roundOverview = this.roundOverview;

            // if (this.scoreScreenMode === "previous-round")
            // {
            //     this.scoreScreen.roundIndex = this.roundOverview.currentRoundData.roundIndex - 1;
            // }
            // else
            // {
            //     this.scoreScreen.roundIndex = null;
            // }

            if (this.rankingScreenMode === "previous-round")
            {
                this.rankingScreen.roundIndex = this.roundOverview.currentRoundData.roundIndex - 1;
            }
            else
            {
                this.rankingScreen.roundIndex = null;
            }

            // this.updateScoreScreen();
            this.updateRankingScreen();
        }
    }

    setRoundOverview(roundOverview)
    {
        this.roundOverview = roundOverview;
        this.refreshRoundData();
    }

    showActionBar(name)
    {
        this.hideActionBars();

        switch (name)
        {
            case "main":
            default:
                this.$actionBarMain.show();
        }
    }

    hideActionBars()
    {
        this.$actionBarMain.hide();
    }

    updateActivePhase()
    {
        $(".ribbon__element").removeClass("active");
        $(`.ribbon__element:nth-of-type(${this.roundOverview.currentRoundData.phase + 1})`).addClass("active");

        $(".next_button-container").removeClass("active");

        if (this.roundOverview.currentRoundData.phase === 2)
        {
            $(".next_button-container").addClass("active");
        }
    }

    clearSidebarResourceData()
    {
        $("[data-bm-current-credits]").html("-");
        $("[data-bm-current-points]").html("-");

        $("[data-bm-current-employees]").html("-");

        $("[data-bm-current-resource-red]").html("-");
        $("[data-bm-current-resource-yellow]").html("-");
        $("[data-bm-current-resource-purple]").html("-");

        $("[data-bm-current-resource-microchip]").html("-");
        $("[data-bm-current-resource-phone]").html("-");
        $("[data-bm-current-resource-bike]").html("-");
    }

    updateResources()
    {
        this.updateResourcesText($("[data-bm-current-credits]"), this.roundOverview.currentRoundData.credits, ".credits .resource-tooltip");
        this.updateResourcesText($("[data-bm-current-points]"), this.roundOverview.currentRoundData.points, ".victory-points .resource-tooltip");

        this.updateResourcesText($("[data-bm-current-employees]"), this.roundOverview.currentRoundData.employees - this.roundOverview.currentRoundData.usedEmployees, ".employees .resource-tooltip");

        this.updateResourcesText($("[data-bm-current-resource-red]"), this.roundOverview.currentRoundData.resourceRed, ".resources-red .resource-tooltip");
        this.updateResourcesText($("[data-bm-current-resource-yellow]"), this.roundOverview.currentRoundData.resourceYellow, ".resources-yellow .resource-tooltip");
        this.updateResourcesText($("[data-bm-current-resource-purple]"), this.roundOverview.currentRoundData.resourcePurple, ".resources-purple .resource-tooltip");

        this.updateResourcesText($("[data-bm-current-resource-microchip]"), this.roundOverview.currentRoundData.resourceMicrochip, ".microchips .resource-tooltip");
        this.updateResourcesText($("[data-bm-current-resource-phone]"), this.roundOverview.currentRoundData.resourcePhone, ".phones .resource-tooltip");
        this.updateResourcesText($("[data-bm-current-resource-bike]"), this.roundOverview.currentRoundData.resourceBike, ".bikes .resource-tooltip");

        $("[data-bm-current-credits]").parents(".resource_wrapper").removeClass("negative").removeClass("positive").addClass(this.roundOverview.currentRoundData.credits >= 0 ? "positive" : "negative");

        if (InvestmentsView.hasPurchasedInvestment(this.team, { title: "phone_factory" }))
        {
            $("#resource_wrapper_phone").show();
        }

        if (InvestmentsView.hasPurchasedInvestment(this.team, { title: "bike_factory" }))
        {
            $("#resource_wrapper_bike").show();
        }
    }

    updateResourcesText(selector, text, tooltipSelector)
    {
        let delta = parseInt(text) - parseInt(selector.html());

        selector.html(text);

        if (tooltipSelector && (!isNaN(delta) && delta !== 0))
        {
            $(tooltipSelector).find("label").text((delta > 0 ? "+" : "") + delta);
            $(tooltipSelector).addClass("active");
            $(tooltipSelector).removeClass("negative");

            if (delta < 0)
            {
                $(tooltipSelector).addClass("negative");
            }

            if (this.resourceTooltipTimeouts[tooltipSelector])
            {
                clearTimeout(this.resourceTooltipTimeouts[tooltipSelector]);
                this.resourceTooltipTimeouts[tooltipSelector] = null;
            }

            this.resourceTooltipTimeouts[tooltipSelector] = setTimeout(() =>
            {
                $(tooltipSelector).removeClass("active");
                this.resourceTooltipTimeouts[tooltipSelector] = null;
            }, 5000);
        }
    }

    setActionButtonState()
    {
        // this.$element.find("[data-bm-current-budget]").text(this.roundOverview.currentRoundData.currentBudget);
        // this.$element.find("[data-bm-current-points]").text(this.roundOverview.currentRoundData.currentPoints);


        let previousRoundScore = this.getRoundScore(this.roundOverview.currentRoundData.roundIndex - 1);
        let hasPreviousRoundScore = utils.isNotNull(previousRoundScore) && previousRoundScore.round !== 0;

        if (hasPreviousRoundScore)
        {
            this.$element.find(".bm-action-btn__score").show();
        }
        else
        {
            this.$element.find(".bm-action-btn__score").hide();
        }

        if (utils.isNotNull(this.roundOverview.currentEvent))
        {
            this.$element.find(".bm-action-btn__event").prop("disabled", false).show();
        }
        else
        {
            this.$element.find(".bm-action-btn__event").prop("disabled", true).hide();
        }
    }

    showEndGameView(endGameData)
    {
        if (!this.rendered)
        {
            this.showBusinessModelOnRender = false;
            this.executeOnRender.push(() => this.showEndGameView(endGameData));
            return;
        }

        this.endGameData = endGameData;

        this.$element.find(".business-model-wrapper").addClass("bm__mode-progress");

        this.$element.find("[data-bm-team-overview-back]").addClass("visibility-hidden");
        this.$element.find(".bm__mode-progress").addClass("visibility-hidden");
        this.showRankingScreen({
            mode: "endgame",
            currentTeam: this.team,
            roundOverview: this.roundOverview,
            interactive: true,
            hideBusinessModel: false
        });
    }

    // ==============================================
    //                    ACTIONS
    // ==============================================

    purchaseInvestment(investment)
    {
        this.investmentDialog.setPurchaseButtonLoading(true);

        if (utils.isFunction(this.onInvestmentAdded))
        {
            this.onInvestmentAdded.call(this, investment);
        }
    }

    assignEmployee(factory)
    {
        if (utils.isFunction(this.onAssignEmployee))
        {
            this.onAssignEmployee.call(this, factory);
        }
    }

    requestNextPhase()
    {
        log.info(`Requesting the next phase, current phase: ${this.roundOverview.currentRoundData.phase}`);

        this.hideAllDialogs();
        // this.hideInvestments();
        // this.hideScoreScreen();
        this.hideRankingScreen();
        this.hideSellProducts();

        this.showLoader(false);

        if (utils.isFunction(this.onNextPhaseRequested))
        {
            this.onNextPhaseRequested.call(this);
        }
    }

    closeRound()
    {
        log.info("Closing round [%d]", this.roundOverview.currentRoundData.roundIndex);

        if (utils.isFunction(this.onTeamClosedRound))
        {
            this.onTeamClosedRound.call(this);
        }
    }

    // ==============================================
    //                    UTILS
    // ==============================================

    getPhase()
    {
        return this.roundOverview.currentRoundData.phase || -1;
    }

    getFreeEmployeeCount()
    {
        return this.roundOverview.currentRoundData.employees - this.roundOverview.currentRoundData.usedEmployees;
    }

    getRoundScore(roundIndex)
    {
        if (utils.isNull(this.roundOverview) || utils.isNull(this.roundOverview.commonDataSelf.roundScores)) return null;

        for (let i = 0; i < this.roundOverview.commonDataSelf.roundScores.length; i++)
        {
            let roundScore = this.roundOverview.commonDataSelf.roundScores[i];
            if (roundScore.round === roundIndex)
            {
                return roundScore;
            }
        }

        return null;
    }

    getInvestmentObjectsForTeam()
    {
        let investments = [];

        // for(let roundIndex in this.team.roundData)
        // {
        //   if(this.team.roundData.hasOwnProperty(roundIndex))
        //   {
        //     let roundData = this.team.roundData[roundIndex];
        //
        //     for(let i = 0; i < this.caseWrapper.investments.length; i++)
        //     {
        //       let investment = this.caseWrapper.investments[i];
        //
        //       if(utils.isNotNull(roundData.investmentKey1) && investment.key === roundData.investmentKey1)
        //       {
        //         investments.push(investment);
        //       }
        //
        //       if(utils.isNotNull(roundData.investmentKey2) && investment.key === roundData.investmentKey2)
        //       {
        //         investments.push(investment);
        //       }
        //     }
        //   }
        // }

        for (let investment in this.team.investmentData)
        {

        }

        return investments;
    }

    // ==============================================
    //                    EVENTS
    // ==============================================
    _setUpEventListeners()
    {
        let nextPhaseButton = $("#btn-next-phase");
        nextPhaseButton.off("click").on("click", async () =>
        {
            console.log("Free spots left: " + this.businessModel.getFreeEmployeeSpotCount());

            let timeoutId = nextPhaseButton.data("seeking-attention-timeout");

            clearTimeout(timeoutId);

            nextPhaseButton.removeClass("seeking-attention");

            let proceed = true;
            if (this.getFreeEmployeeCount() > 0 && this.businessModel.getFreeEmployeeSpotCount() > 0 && this.getPhase() === 1)
            {
                proceed = await new Promise((resolve, reject) =>
                {
                    Shared.Dialog.showYesNoDialog({
                        title: "serious_game.business_model.next_phase.dialog.title",
                        message: "serious_game.business_model.next_phase.dialog.message",
                        onYes: () => resolve(true),
                        onNo: () => resolve(false)
                    });
                });
            }

            if (proceed)
            {
                nextPhaseButton.prop("disabled", "disabled");

                this.requestNextPhase();
            }
        });
    }

    pulsateEventButton()
    {
        log.info("Pulsating event button (possible delay)");

        this.$element.find(".bm-action-btn__event").removeClass("bounce animated").addClass("bounce animated").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function()
        {
            $(this).removeClass("bounce animated");
        });
    }

    pulsateLoanButton()
    {
        log.info("Pulsating event button (possible delay)");

        this.$element.find(".bm-action-btn__loan").removeClass("bounce animated").addClass("bounce animated").one("webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend", function()
        {
            $(this).removeClass("bounce animated");
        });
    }

    onInvestmentClicked(investment)
    {
        log.info("Clicked on investment - %o", investment);
        this.showInvestmentDialog(investment, false);
    }

    onInvestmentDialogCancel(investmentDialog)
    {
        log.info("Investment [%s] cancelled", investmentDialog.investment.type);

        investmentDialog.hide();

        if (investmentDialog.showAsInfo === true)
        {
            return;
        }

        this.showInvestments();

        if (utils.isArray(this.executeOnInvestmentClose))
        {
            // Make copy and clear original
            let executeCopy = this.executeOnInvestmentClose.splice(0);

            for (let i = 0; i < executeCopy.length; i++)
            {
                executeCopy[i].call(this);
            }
        }
    }

    onInvestmentPurchased(investmentDialog)
    {
        log.info("Investment [%s] - purchasing", investmentDialog.investment.type);
        this.purchaseInvestment(investmentDialog.investment);
    }

    onEventDialogCancel()
    {
        log.info("Cancelled event dialog");
        this.hideEventDialog();
        // this.showBusinessModel(true, true);

        if (utils.isArray(this.executeOnEventClose))
        {
            // Make copy and clear original
            let executeCopy = this.executeOnEventClose.splice(0);

            for (let i = 0; i < executeCopy.length; i++)
            {
                executeCopy[i].call(this);
            }
        }
    }
}

module.exports = BusinessModelView;



// WEBPACK FOOTER //
// ./app/js/components/game/views/business-model.js